// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import mintui from 'mint-ui'
import './assets/css/mint-ui.css'
import axios from 'axios'
import uploader from 'vue-simple-uploader'
import VueImg from 'v-img'
import jq from 'jquery'
// import VueTouch from 'vue-touch'
import store from './views/store/index'
import filters from './components/fileters'
import customFunctions from '@/utils/CustomFunction'

import ('./assets/js/template')
import ('./assets/css/common.scss')
import VueLazyLoad from 'vue-lazyload'
import VueTouch from 'vue-touch'

import ('./assets/js/jweixin-1.3.2')

Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })
Array.prototype.remove = function (obj) {
  for (var i = 0; i < this.length; i++) {
    var temp = this[i]
    if (!isNaN(obj)) {
      temp = i
    }
    if (temp == obj) {
      for (var j = i; j < this.length; j++) {
        this[j] = this[j + 1]
      }
      this.length = this.length - 1
    }
  }
}
Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12,
    'H+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  }
  var week = {
    '0': '日',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[this.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
Vue.prototype.$http = axios
Vue.prototype.$customFunctions = customFunctions
Vue.prototype.$customStore = store

Vue.use(uploader)
Vue.use(mintui)
Vue.use(VueImg)
Vue.use(jq)
Vue.config.productionTip = false

window.addEventListener('popstate', function (event) {
  if (window.__wxjs_environment !== 'miniprogram') {
    window.history.pushState('forward', null, '#' + router.history.current.fullPath)
    window.history.forward(1)
  }
})

router.afterEach(function (ref) {
  console.log(ref.path)
  // if (ref.path === '/account/register' || ref.path === '/account/forget' || ref.path === '/modifyPassword') {
  if (ref.path === '/account/register' || ref.path === '/account/forget' || ref.path === '/index' || ref.path === '/modifyPassword') {
  } else {
    if (sessionStorage.getItem('mobileData') === null) {
      router.push({ path: '/login' })
    }
  }
  if (ref.path === '/index') {
    window.sessionStorage.setItem('index', '个人文件')
  }
  if (ref.path === '/shareFile') {
    window.sessionStorage.setItem('shareIndex', '共享文件')
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js